import { render, staticRenderFns } from "./BlogSeoRankComponent.vue?vue&type=template&id=5c9eb64f&scoped=true"
import script from "./BlogSeoRankComponent.vue?vue&type=script&lang=js"
export * from "./BlogSeoRankComponent.vue?vue&type=script&lang=js"
import style0 from "./BlogSeoRankComponent.vue?vue&type=style&index=0&id=5c9eb64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9eb64f",
  null
  
)

export default component.exports